module.exports = __webpack_public_path__ + "media/images/dashboard/goal_portrait-ce641eb6946212225e9746e5abec85ad299e2bb1830caebf5e818788665f7193.png";